import { memo } from "react";
import {
  CampaignFEValues,
  CampaignTriggers,
  CampaignTypes,
} from "types/campaigns";
import { DirectCampaign } from "./DirectCampaign/DirectCampaign";
import { ReferralCampaign } from "./ReferralCampaign/ReferralCampaign";

interface Props {
  errors: any;
  event?: string;
  data: CampaignFEValues;
  isEditMode: boolean;
}

export const CampaignRules = memo(
  ({ data, event, errors, isEditMode }: Props) => {
    const getRulesComponent = (data: CampaignFEValues) => {
      switch (data.type) {
        case CampaignTypes.REFERRAL:
          return (
            <ReferralCampaign
              event={event}
              rules={data.rules}
              trigger={data.trigger}
              transactionItemsFilters={
                data.trigger === CampaignTriggers.TRANSACTION ||
                data.trigger === CampaignTriggers.RETURN_TRANSACTION
                  ? data.transactionItemsFilters
                  : undefined
              }
              errors={errors}
              isEditMode={isEditMode}
            />
          );
        case CampaignTypes.DIRECT:
          return (
            <DirectCampaign
              event={event}
              rules={data.rules}
              trigger={data.trigger}
              transactionItemsFilters={
                data.trigger === CampaignTriggers.TRANSACTION ||
                data.trigger === CampaignTriggers.RETURN_TRANSACTION
                  ? data.transactionItemsFilters
                  : undefined
              }
              errors={errors}
              isEditMode={isEditMode}
            />
          );
        case CampaignTypes.TIME:
          return (
            <DirectCampaign
              event={event}
              rules={data.rules}
              trigger={data.trigger}
              triggerStrategy={data.triggerStrategy}
              errors={errors}
              isEditMode={isEditMode}
            />
          );
      }
    };

    return getRulesComponent(data);
  },
);
